module.exports = __webpack_public_path__ + "img/Iconset_DGBRT--11.a47f6d34.png";